export const trpcConfig = {
	useBatching: true,
}
